<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>ADD CATEGORY</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                Firstly you must add a category in order to add a 
                movie in  that category
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="form"> 
                     <v-text-field label="Name" v-model="name" @keypress="isName" :rules="nameRules" prepend-icon="folder"></v-text-field>
                     <v-textarea label="Description" v-model="desc" :rules="descRules" prepend-icon="edit"></v-textarea>
                     <v-icon>file_upload</v-icon> <span class="flex"><b>   Select Image File  </b> <input type="file" class="file"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select a file</span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Add Category</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addModuleWithAttachment} from '@/model';
import moment from 'moment';

export default {
    name: 'AddCategory',
    data() {
        return {
            isDisabled:false,
            desc:'',
            name:'',
            fileerror:false,
           nameRules:[
               v => v.length >=3  || "Minimum length is 3 characters",
               v => v.length <=10  || "Maximum length is 10 characters",
               
           ],
           descRules:[
               v => v.length >=15  || "Minimum length is 15 characters",
               v => v.length <=200  || "Maximum length is 200 characters" 
           ]

        };
    },
    methods: {
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        add() {
            let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.file');
            
            let file = input.files[0];
            console.log(input.files);
            if(file){
                this.fileerror = false;
                
            }else{
                console.log("Choi")
                this.fileerror = true
                return;
            }
            let useradd = this.$store.getters.getStaff.name;
            console.log(file.type);
            console.log(useradd); 
            let newitem = {name:this.name.toLowerCase(),desc:this.desc,file:file.type,dateadded:datenow,useradd:useradd};
            self.isDisabled = true;
            
              addModuleWithAttachment('category','categories',this.name.toLowerCase(),newitem,file,function(response){
                  if(response){
                      console.log("This is response: ",response);
                      alert('It has been succesfully added to your categories');
                      self.$store.dispatch('updateCategory',true);
                      self.isDisabled = false;
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>